import React, {Component} from 'react';
import {connect} from "react-redux";
import {fetchingBatteriesSelector, myBatteriesSelector} from "../redux/reducers/myBatteriesReducer";
import {openBatteryIdSelector} from "../redux/reducers/openReducer";
import {fetchMyBatteries} from "../redux/actionCreators/myBatteries";
import {dk_blue, dk_gray, dk_light_gray} from "../constants/style";
import {PulseLoader} from "react-spinners";
import MaterialIcon from "material-icons-react";
import {setOpenBattery} from "../redux/actionCreators/open";
import NavLink from "react-router-dom/es/NavLink";
import {connectedSelector, userSelector} from "../redux/reducers/authReducer";
import strings from "../screenLocalisation/connection";
import {disconnect} from "../redux/actionCreators/auth";




class BatteryMenu extends Component {
    constructor(props){
        super(props)
        this.state = {
            menuVisible: true,
            dropDownVisible:false
        }
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    updateDimensions() {
        this.setState({
            menuVisible: !(window.innerWidth < 850)
        })
    }

    componentDidMount() {
        this.props.fetchMyBatteries()
        this.updateDimensions();
    }

    toggleMenu() {
        this.setState({
            menuVisible: !this.state.menuVisible
        })
    }

    toggleDropdown() {
        this.setState( prevState => ({
            dropDownVisible: !prevState.dropDownVisible
        }))
    }

    disconnect() {
        this.props.disconnect()
        this.props.history.push('/login')
    }
    render() {
        return (
            <div>
                <div onClick={this.toggleMenu.bind(this)} className={this.state.menuVisible?'batteryMenuButton':'batteryMenuButton batteryMenuButtonOpen'}>
                    <MaterialIcon key={this.state.menuVisible} color={dk_blue} icon={this.state.menuVisible?'keyboard_arrow_left':'menu'} size={34}/>
                </div>
                {this.state.menuVisible?(
                <div className={'batteryMenu'}>
                    {this.props.batteries.map(battery => (
                        <div key={battery.battery_id}
                             className={battery.battery_id===this.props.openId?'simpleButton simpleButtonSelected':'simpleButton'}
                             onClick={() => this.props.setOpenBattery(battery.battery_id)}
                        >

                            <div className={'topInfo'}>
                                <div className={'batteryAlert'}>
                                    {battery.tor_tempdefault||battery.tor_commdefault||  battery.tor_underchargedefault||battery.tor_overchargedefault||!battery.tor_noalarm?<MaterialIcon color={'red'} icon={'error'} size={24}/>:null}
                                </div>
                                <div  className={'batteryLabel'}>
                                    <p className={'batteryName'}>{battery.name}</p>
                                    <p className={'batterySn'}>S/N: {battery.sn}</p>
                                </div>
                                <div className={'spaceTaker'} />
                            </div>
                            <div className={'loadContainer'}>
                                <p className={' batteryLoader'}>


                                    {'SOC : ' +battery.soc + '%'}
                                </p>
                                <div className={'loader'} style={{width: battery.soc+'%'}}/>
                            </div>
                            {/*<div style={styles.batteryInfos}>*/}
                                {/*<p style={styles.batteryCharge}>{battery.soc}%</p>*/}
                            {/*</div>*/}
                        </div>
                    ))}
                    {this.props.fetching?<div style={styles.loader}><PulseLoader color={dk_blue}/></div>:null}
                    <div style={styles.profileInfo}>
                        <div style={styles.userInfos}>
                            <div style={styles.userText}>
                                <p style={styles.userTextP}>{this.props.user.fullName}</p>
                                {/*<p style={styles.userTextP}>{this.props.user.emailAddress}</p>*/}
                            </div>
                            <div onClick={this.toggleDropdown.bind(this)} className={'profilIcon'}>
                                <div style={styles.profileLogo}>
                                    <div style={styles.logoWrap}>
                                        <MaterialIcon color={'white'} icon={'how_to_reg'} size={50}/>
                                    </div>
                                </div>
                            </div>
                            {this.state.dropDownVisible?<div className={'dropdownMenuProfil'} onClick={this.disconnect.bind(this)}>{strings.disconnect}</div>:null}
                        </div>
                    </div>

                    <img className={'logoMenu'} src={require('../assets/img/logo_blue_small.png')} />

                </div>
                ):null}
            </div>
        );
    }

    batteryHasDefault(battery){
        return battery.tor_overchargedefault||battery.tor_underchargedefault||battery.tor_tempdefault
    }
}



const styles = {

    battery: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: 200,
        padding: 20,
    },
    batteryCharge: {
        color: 'white',
        margin: 0
    },
    batteryAlert: {
        flex: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row',
    },
    batteryLabel: {
        paddingRight: 20,
        flex: 5,
    },
    batteryInfos: {
        flex: 1,
    },
    loader: {
        margin: 20
    },
    userInfos: {
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    profileLogo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    connectIcon: {

    },
    userText: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'space=around',
        padding: '0 20px'
    },
    logoWrap: {
        height: 50
    },
    userTextP: {
        color: 'white'
    },
    profileInfo: {
        position: 'absolute',
        top: 5,
        right: 5
    }
}

const mapStateToProps = state => ({
    batteries: myBatteriesSelector(state),
    fetching: fetchingBatteriesSelector(state),
    openId: openBatteryIdSelector(state),
    connected: connectedSelector(state),
    user: userSelector(state),
})

export default connect(mapStateToProps, {fetchMyBatteries, setOpenBattery, disconnect})(BatteryMenu);
